export const SET_LOGIN = 'SET_LOGIN'
export const SET_USER = 'SET_USER'




// WEBPACK FOOTER //
// ./src/redux/login/types.js